import { motion } from "framer-motion";

const STATUS_COLORS = ["#B91C1C", "#DC2626", "#EF4444", "#E5B80B", "#F59E0B", "#78716C"];

export default function CollectionFunnelChart({ stages: stagesProp } = {}) {
  if (!Array.isArray(stagesProp) || stagesProp.length === 0) {
    return (
      <p className="flex min-h-[160px] items-center justify-center text-sm text-primary/40">
        No case status data yet.
      </p>
    );
  }

  const max = Math.max(1, ...stagesProp.map((s) => Number(s.count) || 0));
  const stages = stagesProp.map((s, i) => ({
    label: s.label,
    count: Number(s.count) || 0,
    width: Math.max(8, Math.round(((Number(s.count) || 0) / max) * 100)),
    color: STATUS_COLORS[i % STATUS_COLORS.length],
  }));

  return (
    <div className="space-y-3.5">
      {stages.map((stage, i) => (
        <div key={stage.label}>
          <div className="mb-1.5 flex items-baseline justify-between gap-2">
            <span className="text-xs font-medium text-primary/65">{stage.label}</span>
            <span className="text-xs font-bold tabular-nums text-primary">
              {stage.count.toLocaleString()}
              <span className="ml-1 font-medium text-primary/40">({stage.width}%)</span>
            </span>
          </div>
          <div className="relative h-7 overflow-hidden rounded-full bg-primary/[0.05]">
            <motion.div
              className="absolute inset-y-0 left-0 rounded-full"
              style={{ backgroundColor: stage.color }}
              initial={{ width: 0 }}
              animate={{ width: `${stage.width}%` }}
              transition={{ duration: 0.75, delay: 0.1 + i * 0.12, ease: "easeOut" }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
